import {PersonEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback, useEffect, useState} from "react";

export type BasePersonMultiSelectProps = Omit<BaseEntityMultiSelectProps<PersonEntity>, "nameMapper"> & {
  reverseName?: boolean;
};

export const BasePersonMultiSelect = (props: BasePersonMultiSelectProps) => {
  const {reverseName = true, entities, ...rest} = props;

  const [sortedData, setSortedData] = useState(entities);

  // name mapper
  const nameMapper = useCallback(
    (e: PersonEntity) => {
      if (reverseName) {
        return e.nameReverse;
      } else {
        return e.name;
      }
    },
    [reverseName]
  );

  // sort freight types by display name
  useEffect(() => {
    const sortedPersons = entities?.sort((a, b) =>
      nameMapper(a).localeCompare(nameMapper(b))
    );
    setSortedData(sortedPersons);
  }, [entities, nameMapper]);

  return <BaseEntityMultiSelect entities={sortedData} nameMapper={nameMapper} {...rest} />;
};
